const valuesSecArr = document.querySelectorAll('.values-sec');
if (valuesSecArr.length) {
  valuesSecArr.forEach(valuesSec => {
    const mobileMediaQuery = window.matchMedia('(max-width: 640px)');
    const valuesSecContainer = valuesSec.querySelector(
      '.values-sec__container'
    );
    const valuesTabsWr = valuesSecContainer?.querySelector(
      '.values-sec__tabs'
    );
    const valuesImagesWr = valuesSecContainer?.querySelector(
      '.values-sec__images'
    );

    if (!valuesSecContainer || !valuesTabsWr) return;

    const valuesImagesArr = valuesImagesWr
      ? [...valuesImagesWr.querySelectorAll('.values-sec__image')]
      : [];
    const valuesItemsArr = [
      ...valuesTabsWr.querySelectorAll('.values-sec__item'),
    ];

    if (!valuesItemsArr.length) return;

    const imagesByValueIndex = new Map(
      valuesImagesArr
        .map(image => [Number(image.dataset.valuesImageIndex), image])
        .filter(([index]) => Number.isInteger(index))
    );

    const getLineHeight = element => {
      const { lineHeight, fontSize } = window.getComputedStyle(element);
      const parsedLineHeight = parseFloat(lineHeight);
      const parsedFontSize = parseFloat(fontSize);
      const fallbackLineHeight =
        Number.isFinite(parsedFontSize) && parsedFontSize > 0
          ? parsedFontSize * 1.5
          : 0;

      if (lineHeight === 'normal') {
        return Math.ceil(fallbackLineHeight);
      }

      if (Number.isFinite(parsedLineHeight) && parsedLineHeight > 0) {
        return Math.ceil(parsedLineHeight);
      }

      return Math.ceil(fallbackLineHeight);
    };

    const updateItemsHeights = () => {
      valuesItemsArr.forEach(item => {
        const itemContent = item.querySelector('.values-sec__item-content');
        const itemText = item.querySelector('.values-sec__item-text');

        if (!itemContent || !itemText) return;

        const textLineElement = itemText.querySelector('p, li') || itemText;
        const collapsedHeight = Math.ceil(getLineHeight(textLineElement) * 2) + 2;
        const expandedHeight = Math.max(
          Math.ceil(itemContent.scrollHeight + 24),
          collapsedHeight
        );

        itemContent.style.maxHeight = `${
          item.classList.contains('is-active')
            ? expandedHeight
            : collapsedHeight
        }px`;
      });
    };

    const syncImagesPlacement = () => {
      if (!valuesImagesWr) return;

      if (!mobileMediaQuery.matches) {
        valuesImagesArr.forEach(image => valuesImagesWr.appendChild(image));
        return;
      }

      valuesItemsArr.forEach((item, index) => {
        const image = imagesByValueIndex.get(index);
        const slot = item.querySelector('[data-values-image-slot]');

        if (image && slot) {
          slot.appendChild(image);
        }
      });
    };

    if (!valuesItemsArr[0].classList.contains('is-active')) {
      valuesItemsArr[0].classList.add('is-active');
    }

    const setActiveValue = index => {
      valuesItemsArr.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
      });

      valuesImagesArr.forEach(image => {
        image.classList.toggle(
          'is-active',
          Number(image.dataset.valuesImageIndex) === index
        );
      });

      updateItemsHeights();
    };

    const activeItemIndex = valuesItemsArr.findIndex(item =>
      item.classList.contains('is-active')
    );
    const initialIndex =
      activeItemIndex >= 0
        ? activeItemIndex
        : 0;

    setActiveValue(initialIndex);
    syncImagesPlacement();
    window.addEventListener('resize', updateItemsHeights);

    const handleMobileLayoutChange = () => {
      syncImagesPlacement();
      updateItemsHeights();
    };

    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', handleMobileLayoutChange);
    } else {
      mobileMediaQuery.addListener(handleMobileLayoutChange);
    }

    valuesItemsArr.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('is-active')) {
          updateItemsHeights();
          return;
        }

        setActiveValue(index);
      });
    });
  });
}
